export default __webpack_public_path__ + "/static/media/loader.130a90f4.gif";